<template>
<!--  <b-nav-item-dropdown
    class="dropdown-notification mr-25"
    menu-class="dropdown-menu-media"
    right
  >
    <template #button-content>
      <feather-icon
        class="text-body"
        icon="BellIcon"
        size="21"
      />
      <span class="position-absolute" style="top: -4px;left:20px;background: red;color: #fff;font-size: 12px">
          جدید
        </span>
    </template>

    &lt;!&ndash; Header &ndash;&gt;
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex">
        <h4 class="notification-title mb-0 mr-auto">
           آخرین تراکنش ها موفق
        </h4>
&lt;!&ndash;        <b-badge
          pill
          variant="light-primary"
        >
          6 جدید
        </b-badge>&ndash;&gt;
      </div>
    </li>

    &lt;!&ndash; Notifications &ndash;&gt;
    <b-link
        v-for="item in transactions" :key="item.id"
    >
      <b-media v-if="item.status=='success'" style="padding: 5px;border-bottom: 1px solid #eee">
        <template #aside>
          {{ item.user }}
        </template>
        <p class="media-heading">
            <span class="font-weight-bolder">
               {{ item.order.service_name }}
            </span>
        </p>
        <small class="notification-text">
            <span>
                  <span>تاریخ ورود یا رزرو : </span>
                  <b-badge variant="info" v-if="item.order.checkin">
                    {{ new Date(item.order.checkin).toLocaleString('fa-IR').split(",")[0]}}
                  </b-badge>
                  <br/>
                  <span v-if="item.order.checkout">
                      <span>تاریخ خروج : </span>
                      <b-badge variant="info" v-if="item.order.checkout">
                        {{ new Date(item.order.checkout).toLocaleString('fa-IR').split(",")[0]}}
                      </b-badge>
                  </span>
                  <span v-if="item.order.duration>0">
                     <span>تعداد شب/مدت اجرا  : </span>
                     <b-badge variant="info" v-if="item.order.checkout">
                      {{ item.order.duration }} شب/اجرا
                     </b-badge>
                  </span>
            </span>
        </small>
      </b-media>
    </b-link>

    &lt;!&ndash; Cart Footer &ndash;&gt;
    <li class="dropdown-menu-footer">
      <div>
        <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="relief-info"
            to="reservationSpace"
            class="mx-1"
        >
           اقامتگاه
        </b-button>
        <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="relief-info"
            to="reservationEvent"
        >
           تجربه
        </b-button>
        <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="relief-info"
            to="reservationCar"
            class="mx-1"
        >
           ترانسفر
        </b-button>
        <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="relief-info"
            to="reservationTour"
        >
           تور
        </b-button>
      </div>
    </li>
  </b-nav-item-dropdown>-->
</template>

<script>
import {
  BNavItemDropdown, BBadge, BMedia, BLink, BAvatar, BButton, BFormCheckbox,
} from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BNavItemDropdown,
    BBadge,
    BMedia,
    BLink,
    BAvatar,
    VuePerfectScrollbar,
    BButton,
    BFormCheckbox,
  },
  directives: {
    Ripple,
  },
  props:['transactions'],
  setup() {
    /* eslint-disable global-require */
/*    const notifications = [
      {
        title: 'Congratulation Sam 🎉',
        avatar: require('@/assets/images/avatars/6-small.png'),
        subtitle: 'Won the monthly best seller badge',
        type: 'light-success',
      },
      {
        title: 'New message received',
        avatar: require('@/assets/images/avatars/9-small.png'),
        subtitle: 'You have 10 unread messages',
        type: 'light-info',
      },
      {
        title: 'Revised Order 👋',
        avatar: 'MD',
        subtitle: 'MD Inc. order updated',
        type: 'light-danger',
      },
    ]
    /!* eslint-disable global-require *!/

    const systemNotifications = [
      {
        title: 'Server down',
        subtitle: 'USA Server is down due to hight CPU usage',
        type: 'light-danger',
        icon: 'XIcon',
      },
      {
        title: 'Sales report generated',
        subtitle: 'Last month sales report generated',
        type: 'light-success',
        icon: 'CheckIcon',
      },
      {
        title: 'High memory usage',
        subtitle: 'BLR Server using high memory',
        type: 'light-warning',
        icon: 'AlertTriangleIcon',
      },
    ]*/

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    }

    return {
      perfectScrollbarSettings,
    }
  },
}
</script>

<style>

</style>
